<template>
  <div>
    <form-wizard
      color="#7367F0"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Simpan"
      back-button-text="Kembali"
      class="mb-3"
      @on-complete="formSubmitted"
    >

      <!-- accoint details tab -->
      <tab-content
        title="Profil Peserta"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col md="12">
             <lembar-kehidupan />
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Rekomendasi"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
        <b-tabs>
          <b-tab v-for="(item, index) in rekomendasi" :key="item.id" :title="item.nama">
            <b-container>
              <b-row>
                <b-col md="12">
                  <rekomendasi-disabled :token="item.token" />
                </b-col>
              </b-row>
            </b-container>
          </b-tab>
        </b-tabs>
        </validation-observer>
      </tab-content>

      <tab-content
        title="Assessment"
        :before-change="validationForm"
      >
        <validation-observer
          ref="accountRules"
          tag="form"
        >
          <b-row>
            <b-col md="12">
             <assessment-disabled />
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
      <tab-content
        title="Hasil Tes Materi Profesi Psikologi"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row class="ml-2 mb-2 mr-3">
            <b-col>
              <h4>Hasil Tes Materi Profesi Psikologi</h4>
              <b-table :items="items4" :fields="fields4" striped hover>
                <template #cell(hasil_psikogram)="data">
                  {{ data.item.hasil_psikogram }}
                </template>
                <template #cell(keterangan)="data">
                  {{ data.item.keterangan }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content> 
      <!-- personal details tab -->
      <tab-content
        title="Lembar Penilaian"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row class="ml-2 mb-2 mr-3">
            <b-col>
              <h4>Ketentuan Penilaian</h4>
              <b-table :items="items2" :fields="fields2" striped hover>
                <template #cell(hasil_psikogram)="data">
                  {{ data.item.hasil_psikogram }}
                </template>
                <template #cell(keterangan)="data">
                  {{ data.item.keterangan }}
                </template>
              </b-table>
            </b-col>
            <b-col>
              <h4>Keterangan</h4>
              <b-table :items="items3" :fields="fields3" striped hover>
                <template #cell(hasil_psikogram)="data">
                  {{ data.item.hasil_psikogram }}
                </template>
                <template #cell(keterangan)="data">
                  {{ data.item.keterangan }}
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="mb-2 ml-2" md="12" v-for="item in psikogram" :key="`${item.id}-pskgrm`">
              <h5 class="mb-2">{{ item.header }}</h5>
              <div v-for="detail in item.detail" :key="`${item.detail.id}-dt`">  
                <b-row class="ml-2 mb-2 mr-3" v-if="detail.tipe != 'textarea'">
                  <b-col md="4">
                    <h6> <b> {{ detail.title }} </b></h6>
                    <label for="">{{ detail.pertanyaan }}</label>
                  </b-col>
                  <b-col md="4">
                    <b-form-group
                      label=""
                      label-for=""
                    >
                      <b-form-select
                        v-if="detail.tipe != 'radio'"
                        v-model="detail.jawaban"
                        name="jawaban"
                        :options="[
                          { value: '1', text: '1. Kurang Baik' },
                          { value: '2', text: '2. Kurang' },
                          { value: '3', text: '3. Baik' },
                          { value: '4', text: '4. Sangat Baik' }
                        ]"
                        placeholder="Pilih skor 1 - 4"
                      />
                      <b-form-radio-group v-model="detail.jawaban" :id="`rating-options-${detail.id}`" v-else>
                        <b-form-radio :value="'baik'">Baik</b-form-radio>
                        <b-form-radio :value="'cukup'">Cukup</b-form-radio>
                        <b-form-radio :value="'kurang'">Kurang</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <validation-provider
                      #default="{ errors }"
                      name="Catatan"
                      rules="required"
                    :messages="{
                      required: 'Bagian ini wajib diisi'
                    }"
                    >
                      <b-form-input
                          v-model="detail.catatan"
                          name="catatan"
                          placeholder="Catatan"
                        />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                </b-row>
                <b-row class="ml-2 mb-2 mr-3" v-else>
                  <b-col md="4">
                    <b-form-group
                      :label="detail.title"
                      label-for=""
                    >
                    <label for="">{{ detail.pertanyaan }}</label>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label=""
                      label-for=""
                    >
                      <b-form-textarea
                        v-model="detail.jawaban"
                        name="jawaban"
                        placeholder="Catatan"
                        rows="5"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
          <b-row class="ml-2 mb-2 mr-3">
            <b-col>
              <h3>Rekomendasi</h3>
              <b-table :items="items" :fields="fields" striped hover>
                <template #cell(hasil_psikogram)="data">
                  {{ data.item.hasil_psikogram }}
                </template>
                <template #cell(keterangan)="data">
                  {{ data.item.keterangan }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormRadioGroup,
  BFormTextarea,
  BTab, BTabs, BContainer,
  BFormRadio,BTable, BFormSelect, BFormSelectOption
  
} from 'bootstrap-vue'
import { required, email } from '@validations'
extend('required', {
    ...required,
    message: 'Bagian ini wajib diisi',
});
import { codeIcon } from './code'
import {
  getPertanyaanPerekomendasi,
  simpanJawabanPerekomendasi,
  getPsikogram,
  simpanPsikogram,
  getTokenRekomendasi,
} from '@/connection-api/master'
import lembarKehidupan from '@/views/pages/lembar-kehidupan-disabled/FormWizard.vue'
// import rekomendasiDisabled from '@/views/pages/rekomendasi-disabled/Form.vue'
import assessmentDisabled from '@/views/pages/assessment-disabled/FormWizard.vue'
import rekomendasiDisabled from '@/views/pages/perekomendasi-disabled/FormWizard.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormRadioGroup,
    BFormTextarea,
    lembarKehidupan,
    assessmentDisabled,
    rekomendasiDisabled,
    BTab, BTabs, BContainer, BFormRadio, BTable, BFormSelect, BFormSelectOption
  },
  data() {
    return {
      summary: {},
      rekomendasi: {},
      psikogram: {},
      pemberi_rekomendasi: {},
      penilaian: {},
      penilaian_rekomendasi: {},
      kesediaan: {},
      uraian: {},
      rawData: {},
      selectedContry: '',
      selectedLanguage: '',
      name: '',
      emailValue: '',
      PasswordValue: '',
      passwordCon: '',
      first_name: '',
      last_name: '',
      address: '',
      landMark: '',
      pincode: '',
      twitterUrl: '',
      facebookUrl: '',
      googleUrl: '',
      linkedinUrl: '',
      city: '',
      required,
      email,
      codeIcon,
      fields: [
        { key: 'hasil_psikogram', label: 'Hasil Psikogram' },
        { key: 'keterangan', label: 'Keterangan Rekomendasi' }
      ],
      items: [
        // { hasil_psikogram: '100', keterangan: 'Baik' },
      ],
      fields2: [
        { key: 'hasil_psikogram', label: 'Sangat Baik' },
        { key: 'keterangan', label: 'Baik' },
        { key: 'kurang', label: 'Kurang' },
        { key: 'sangat_kurang', label: 'Kurang Baik' },
      ],
      items2: [
        { hasil_psikogram: '4', keterangan: '3', kurang: '2', sangat_kurang: '1' },
      ],
      fields4: [
        { key: 'nilai_tkd', label: 'Nilai Materi Profesi Psikologi' },
        // { key: 'keterangan', label: 'Tidak Disarankan' },
      ],
      items4: [
        { nilai_tkd: '0'},
        // { hasil_psikogram: '< 46', keterangan: 'Tidak Disarankan' },
      ],
      fields3: [
        { key: 'hasil_psikogram', label: 'Disarankan' },
        { key: 'keterangan', label: 'Tidak Disarankan' },
      ],
      items3: [
        { 
          hasil_psikogram: process.env.VUE_APP_PSIKOGRAM_DISARANKAN_RANGE || '46 - 52', 
          keterangan: 'Disarankan' 
        },
        { 
          hasil_psikogram: process.env.VUE_APP_PSIKOGRAM_TIDAK_DISARANKAN || '< 46', 
          keterangan: 'Tidak Disarankan' 
        },
      ],
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      kapasitasOptions: {
        selected: 'id',
        options: [
          { value: null, label: 'Pilih Kapasitas' },
          { value: 'pembimbing akademik', label: 'Pembimbing Akademik' },
          { value: 'pembimbing skripsi', label: 'Pembimbing Skripsi' },
          { value: 'pembimbing tesis', label: 'Pembimbing Tesis' },
          { value: 'pembimbing disertasi', label: 'Pembimbing Disertasi' },
          { value: 'atasan', label: 'Atasan' },
          { value: 'lainnya', label: 'Lainnya' },
        ],
      },
      selected: 'first',
        options: [
          { text: 'Dibawah Rata Rata (Below Average)', value: 'dibawah' },
          { text: 'Rata Rata (Average)', value: 'rata rata' },
          { text: 'Baik (Above Avegrage)', value: 'baik' },
          { text: 'Sangat Baik (Superior)', value: 'sangat baik' }
        ],
        optionsPR: [
          { text: 'Saya sangat merekomendasikan Peserta untuk mengikuti program studi  (I highly recommend Participants to enroll the psychology professional study program)', value: 'sangat merekomendasikan' },
          { text: 'Saya merekomendasikan Peserta untuk mengikuti program studi   (I recommend participants to enroll a professional psychology study program)', value: 'merekomendasikan' },
          { text: 'Saya tidak merekomendasikan Peserta untuk mengikuti program studi  (I do not recommend participants to enroll the professional psychology study program)', value: 'tidak merekomendasikan' },
          { text: 'Saya tidak dapat memberikan komentar  (I cant comment)', value: 'tidak berkomentar' }
        ],
        optionsBA: [
          { text: 'Saya bersedia dihubungi (baik melalui email maupun telepon) untuk konfirmasi penilaian Peserta. (I am willing to be contacted (either via email or telephone) for the confirmation of the assessment of the Participant)', value: 'bersedia dikontak' },
          { text: 'Saya tidak bersedia dihubungi. (I dont want to be contacted).', value: 'tidak bersedia dikontak' },
        ],
    }
  },
  mounted() {
    const tempData = {
      token: this.$route.params.token
    }
    getPsikogram(tempData)
    .then(response => {
      if (response.data.success == true) {
        this.psikogram = response.data.data
        this.items = response.data.rekomendasi
        this.summary = response.data.summary
        this.items4[0].nilai_tkd = this.summary.nilai_tkd
      }
    })
    .catch(error => console.log(error));

    getTokenRekomendasi(this.$route.params.token)
    .then(response => {
      if (response.data.success == true) {
        this.rekomendasi = response.data.data
      }
    })
    .catch(error => console.log(error));
  },
  methods: {
    formSubmitted() {
      const data = {
        token: this.$route.params.token,
        psikogram: this.psikogram,
      }
      simpanPsikogram(data)
      .then(response => {
        if (response.data.success == true) {
            this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Data berhasil disimpan',
              icon: 'EditIcon',
              variant: 'success',
            },
          })
          this.$router.go(0)
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Data gagal disimpan',
              icon: 'EditIcon',
              variant: 'danger',
            },
          })
        }
      })
      .catch(error => console.log(error));
     
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            // reject()
            resolve(true)
          }
        })
      })
    },
  },
}
</script>
<style>
.form-group label {
  font-size:1em!important;
}
</style>